import Vuex from 'vuex';
import Vue from 'vue';
import {state, mutations, actions, getters} from './application';

const storeState = require.context('@/pages', true, /store.js$/);

console.log("这里stroe", storeState);

const toFirstUpperCase = moduleName => moduleName.replace(/[/\\]/g, '_');

const modules = ((store) => {
  const module = {};
  store.keys().forEach(name => {
    const n = name.match(/\.[\\/]([^.]*)[\\/]store.js$/);
    const moduleName = n ? n[1] : 'root';
    const s = store(name);
    const m = s && s.default ? s.default : s;
    m.namespaced = true;
    module[toFirstUpperCase(moduleName)] = m;
  });
  return module;
})(storeState);

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js